import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { theme } from '@cta-portal/webapp-common/lib/app/theme';
import { ThemeProvider } from 'styled-components';
import GlobalTooltip from '../components/common/global-tooltip';
import ContextProvider from '../context';
import GlobalStyle from './global-style';
import './i18n';
import Router from './router';
export default function App() {
    return (_jsx(ContextProvider, { children: _jsxs(ThemeProvider, { theme: theme, children: [_jsx(GlobalStyle, { theme: theme }), _jsx(Router, {}), _jsx(GlobalTooltip, {})] }) }));
}
